module.exports = __webpack_public_path__ + "img/doctor-profile-generic-man.7e593da3.svg";